import React from 'react';
import { MenuIcon, BellIcon, GlobeIcon } from 'lucide-react';
import { ownerData } from '../data/sampleData';
interface HeaderProps {
  title: string;
  onMenuClick: () => void;
  notificationCount: number;
  navigate: (page: string) => void;
  language: 'en' | 'bn';
  setLanguage: (lang: 'en' | 'bn') => void;
}
export function Header({
  title,
  onMenuClick,
  notificationCount,
  navigate,
  language,
  setLanguage
}: HeaderProps) {
  return <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 lg:px-8 sticky top-0 z-20" data-id="element-66">
      <div className="flex items-center gap-4" data-id="element-67">
        <button onClick={onMenuClick} className="p-2 -ml-2 text-slate-500 hover:bg-slate-100 rounded-lg lg:hidden" data-id="element-68">
          <MenuIcon className="w-6 h-6" data-id="element-69" />
        </button>
        <h1 className="text-xl font-bold text-slate-800" data-id="element-70">{title}</h1>
      </div>

      <div className="flex items-center gap-2 sm:gap-4" data-id="element-71">
        {/* Language Switcher */}
        <div className="flex items-center bg-slate-100 rounded-lg p-1" data-id="element-72">
          <button onClick={() => setLanguage('en')} className={`px-2 py-1 text-xs font-medium rounded ${language === 'en' ? 'bg-white text-[#006A4E] shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-73">
            EN
          </button>
          <button onClick={() => setLanguage('bn')} className={`px-2 py-1 text-xs font-medium rounded ${language === 'bn' ? 'bg-white text-[#006A4E] shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-74">
            বাংলা
          </button>
        </div>

        <button onClick={() => navigate('notifications')} className="relative p-2 text-slate-500 hover:bg-slate-100 rounded-full transition-colors" data-id="element-75">
          <BellIcon className="w-5 h-5" data-id="element-76" />
          {notificationCount > 0 && <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-[#C8102E] rounded-full border border-white" data-id="element-77"></span>}
        </button>

        <div className="flex items-center gap-3 pl-2 sm:pl-4 border-l border-slate-200 cursor-pointer hover:opacity-80 transition-opacity" onClick={() => navigate('profile')} data-id="element-78">
          <div className="hidden md:block text-right" data-id="element-79">
            <p className="text-sm font-semibold text-slate-800" data-id="element-80">
              {ownerData.name}
            </p>
            <p className="text-xs text-slate-500" data-id="element-81">Verified Owner</p>
          </div>
          <div className="w-9 h-9 rounded-full bg-[#006A4E] text-white flex items-center justify-center font-bold text-sm shadow-sm border-2 border-white ring-2 ring-slate-100 shrink-0" data-id="element-82">
            MR
          </div>
        </div>
      </div>
    </header>;
}